import React, { useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useLanguage } from '../../hooks/useLanguage'

const ProWorks = () => {
  const { lang } = useLanguage()

  return (
    <section id='casestudy'>
      <h2 className='text-[32px] font-bold text-center text-[#333] tracking-3 toppan'>施行事例</h2>
      <p className='py-8 text-xl text-center text-[#333] leading-170'>
        以下弊社が実際にお手伝いさせていただいた村上医院様の事例です。
      </p>
      <div className='flex flex-col lg:flex-row gap-6 lg:gap-12 py-8 lg:py-10'>
        <div className='lg:w-1/2'>
          <StaticImage
            src='../../img/pro/step1.webp'
            className='object-cover sm:w-1/2'
            alt='ステップ1'
            loading='lazy'
          />
          <h3 className='text-[28px] font-medium text-left text-[#333] py-4 leading-170'>デザイン変更＆パフォーマンス向上</h3>
          <p className='text-xl text-left text-[#333] leading-170'>
            まず、ロゴの変更/コンセプトカラーの設定等のブランディング、モバイル対応したモダンなデザインへの変更等によりWebサイトの最適化を行い、サイトのパフォーマンスをを向上しました。
          </p>
        </div>
        <StaticImage
          src='../../img/pro/step1img.webp'
          className='object-cover lg:w-1/2'
          alt='クリニックのサイトパフォーマンス'
          loading='lazy'
        />
      </div>
      <div className='flex flex-col lg:flex-row-reverse gap-6 lg:gap-12 py-8 lg:py-10'>
        <div className='lg:w-1/2'>
          <StaticImage
            src='../../img/pro/step2.webp'
            className='object-cover sm:w-1/2'
            alt='ステップ2'
            loading='lazy'
          />
          <h3 className='text-[28px] font-medium text-left text-[#333] py-4 leading-170'>検索ランキングの向上</h3>
          <p className='text-xl text-left text-[#333] leading-170'>
            検索からの流入がほとんどなかったウェブサイトも最適化を行なったことにより検索結果が上昇し、今では１ページ目に表示されています。
          </p>
        </div>
        <StaticImage
          src='../../img/pro/step2img.webp'
          className='object-cover lg:w-1/2'
          alt='Yahoo Japanの検索ランキング'
          loading='lazy'
        />
      </div>
      <div className='flex flex-col lg:flex-row gap-6 lg:gap-12 py-8 lg:py-10'>
        <div className='lg:w-1/2'>
          <StaticImage
            src='../../img/pro/step3.webp'
            className='object-cover sm:w-1/2'
            alt='ステップ3'
            loading='lazy'
          />
          <h3 className='text-[28px] font-medium text-left text-[#333] py-4 leading-170'>モニタリング/分析/改善</h3>
          <p className='text-xl text-left text-[#333] leading-170'>
            グーグルのアルゴリズムは日々変化します。
            放置してしまうとその変化に気づかずWebサイトのパフォーマンスが下がってきます。
            リニューアル後でデータを観察/分析し、悪いところは改善していきます。
          </p>
        </div>
        <StaticImage
          src='../../img/pro/step3img.webp'
          className='object-cover lg:w-1/2'
          alt='データのモニタリング、分析'
          loading='lazy'
        />
      </div>
      <div className='flex flex-col lg:flex-row-reverse gap-6 lg:gap-12 py-8 lg:py-10'>
        <div className='lg:w-1/2'>
          <StaticImage
            src='../../img/pro/successStep.webp'
            className='object-cover sm:w-1/2'
            alt='サクセス'
            loading='lazy'
          />
          <p className='text-xl text-left text-[#333] py-6 leading-170'>
            SEO対策によりホームページが上位に表示されることで広告を使わないオーガニック検索での流入が増え
            集客コストを抑えながら、売上を更に上げるこという好循環が生まれます。
          </p>
        </div>
        <StaticImage
          src='../../img/pro/success.webp'
          className='object-cover lg:w-1/2'
          alt='売り上げ向上'
          loading='lazy'
        />
      </div>
    </section>
  )
}

export default ProWorks
